export default "__VITE_ASSET__DnvbemmZ__"